import { Validators } from '@angular/forms';
import { FormFieldTypeEnum } from '@shared/components/pm-form/models/enums/formFieldType.enum';
import { IFormConfig } from '@shared/components/pm-form/models/formConfig.model';

export const COOKIES_FORM_CONFIG: IFormConfig = {
  rawValues: true,
  formLabel: '',
  sections: [
    {
      groupName: 'cookies',
      groupLabel: $localize`Ustawienia plików cookie`,
      fields: [
        {
          name: 'required_cookies',
          type: FormFieldTypeEnum.SWITCH,
          label: $localize`Niezbędne pliki cookie`,
          required: true,
          validators: [Validators.required],
          value: true,
          disabled: true,
        },
        {
          name: 'analytics_cookies',
          type: FormFieldTypeEnum.SWITCH,
          label: $localize`Analityka i statystyki`,
          value: true,
        },
      ],
    },
  ],
};
